module.exports = __webpack_public_path__ + "img/spinning-allow.75641315.svg";